import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export const InfoBlockColumn = ({ label, lines, withTranslation = false }) => {
  const { t } = useLocalize()
  return (
    <>
      <div className="tw-text-sm">
        <label className="tw-mb-0 tw-py-0.5 tw-font-medium">{label}</label>
        <div className="">
          {lines.map((line: string, i) => (
            <div key={i}>{withTranslation ? t(line) : (line ?? '-')}</div>
          ))}
        </div>
      </div>
    </>
  )
}

export const InfoBlockRow = ({
  label = null,
  lines,
  withTranslation = false,
}) => {
  const { t } = useLocalize()
  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-pl-2 tw-text-sm md:tw-max-w-[500px]">
        {label && (
          <label className="tw-mb-0 tw-flex-1 tw-py-0.5 tw-font-medium">
            {label}
          </label>
        )}
        <div className="tw-flex tw-flex-1 tw-flex-col tw-items-end md:tw-items-start">
          {lines.length === 0 ? (
            <div>--:--</div>
          ) : (
            lines.map((line, i) => (
              <div key={i}>
                {withTranslation && line ? t(line) : (line ?? '--:--')}
              </div>
            ))
          )}
        </div>
      </div>
    </>
  )
}

export const InfoBlockRowWithSubInfo = ({
  label,
  subLabel,
  lines,
  withTranslation = false,
}) => {
  const { t } = useLocalize()
  return (
    <>
      <div className="tw-space-y-2 tw-text-sm md:tw-max-w-[500px]">
        <label className="tw-mb-0 tw-py-0.5 tw-font-medium">{label}</label>
        <div className="tw-font-base tw-flex tw-items-center tw-justify-between tw-text-sm">
          <div className="tw-flex-1">{subLabel}</div>
          <div className="text-end tw-flex tw-flex-1 tw-justify-end md:tw-justify-start">
            {lines.length === 0 ? (
              <div>--:--</div>
            ) : (
              lines.map((line, i) => (
                <div key={i}>
                  {withTranslation && line ? t(line) : (line ?? '--:--')}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  )
}
